import { Grid, CardHeader, CardContent, Box, TextField, CircularProgress, Avatar, Button, MenuItem, Select, FormHelperText } from "@mui/material";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { apiCategory, Teams, ticketServices } from "../../services/AllServices";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { capitalizeFirstLetter } from "../../utils/helpers";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import errorHandler from "../../utils/errorHandler";
import { IMAGE_BASE } from "../../utils/constants";
import LoadingButton from "@mui/lab/LoadingButton";
import CardLayout from "../../layouts/CardLayout";
import { TicketSchema } from "../../utils/Schema";
import { toast } from "react-toastify";
import dayjs from "dayjs";

function AddEditTicket() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [data, setData] = useState();
  const [subcategories, setSubcategories] = useState([]);
  const [Childsubcategories, setSubChildcategories] = useState([]);
  const [isSportCategory, setIsSportCategory] = useState(false);
  const [categories, setCategories] = useState([]);
  const [teamData, setTeamData] = useState([]);

  const [venueImage, setVenueImage] = useState(null);
  const [venueImagePreview, setVenueImagePreview] = useState(null);
  const venueImageInputRef = useRef(null);

  const { id } = useParams();

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await ticketServices.getById({ id });
        const resData = response?.data?.data;

        setImagePreview(IMAGE_BASE + resData?.image);
        setVenueImagePreview(IMAGE_BASE + resData?.venueImage);
        setData(resData);

        formik.setFieldValue("country", resData?.country || "");
        formik.setFieldValue("state", resData?.state || "");
        formik.setFieldValue("city", resData?.city || "");

        if (resData?.country) {
          const stateResponse = await ticketServices.getStatesByCountry({
            countryId: resData.country,
            type:"dropdown"
          });

          setStates(stateResponse?.data?.data || []);
        }

        if (resData?.state) {
          const cityResponse = await ticketServices.getCity({
            stateId: resData.state,
            type:"dropdown"
          });
          console.log(cityResponse?.data?.data)
          setCities(cityResponse?.data?.data || []);
        }

        if (resData?.originIds[0]?.slug) {
          setIsSportCategory(
            resData?.originIds[0]?.slug.toLowerCase() === "sports"
          );
        }
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  const fetchCategoriesData = async (req, res) => {
    try {
      const response = await apiCategory.category();
      setCategories(response?.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    fetchTaskData();
    fetchCategoriesData();
  }, [fetchTaskData]);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: TicketSchema,
    // validate: (values) => {
    //   const errors = {};

    //   if (Childsubcategories?.length > 0 && !values.subcategoryId) {
    //     errors.subcategoryId = "Sub category is required";
    //   }

    //   return errors;
    // },
    initialValues: {
      name: data?.name || "",
      image: data?.image || "",
      bidPrice: data?.bidPrice || "",
      price: data?.price || "",
      totalTicket: data?.totalTicket || "",
      slug: data?.originIds?.[0]?.slug || "",
      categoryId: data?.originIds?.[1]?.id || "",
      subcategoryId: data?.originIds?.[2]?.id || "",
      description: data?.description || "",
      status: data?.status || "active",
      teamFirst: data?.teamFirst || "",
      teamSecond: data?.teamSecond || "",
      artistName: data?.artistName || "",
      city: data?.city || "",
      state: data?.state || "",
      country: data?.country || "",
      venue: data?.venue || "",
      zipcode: data?.zipcode || "",
      fullAddress: data?.fullAddress || "",
      row: data?.row || "",
      section: data?.section || "",
      venueImage: data?.venueImage || "",
      event_start_date: data?.event_start_date ? dayjs(data?.event_start_date) : null,
    },

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();

        if (id) {
          formData.append("id", id);
        }

        formData.append("name", values.name);
        formData.append("bidPrice", values.bidPrice);
        formData.append("price", values.price);
        formData.append("totalTicket", values.totalTicket);
        formData.append("imagePath", "ticket");
        formData.append("slug", values.slug);
        formData.append("city", values.city);
        formData.append("state", values.state);
        formData.append("venue", values.venue);
        formData.append("country", values.country);
        formData.append("zipcode", values.zipcode);
        formData.append("fullAddress", values.fullAddress);
        formData.append("event_start_date", values.event_start_date);
        formData.append("row", values.row);
        formData.append("section", values.section);
        formData.append("categoryId", values.categoryId);

        if (values.slug === "sports") {
          formData.append("teamFirst", values.teamFirst);
          formData.append("teamSecond", values.teamSecond);
        } else {
          formData.append("artistName", values.artistName);
        }
        if (values.subcategoryId) {
          formData.append("subcategoryId", values.subcategoryId);
        }
        formData.append("description", values.description);
        formData.append("status", values.status);
        if (selectedImage && selectedImage !== data?.image) {
          formData.append("image", selectedImage);
        }

        if (venueImage && venueImage !== data?.venueImage) {
          formData.append("venueImage", venueImage);
        }

        const response = id
          ? await ticketServices.edit(formData)
          : await ticketServices.add(formData);

        toast.success(response?.data?.message, { toastId: "success" });
        navigate(-1);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleImageChange = (event) => {
    const file = event.currentTarget.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];

    if (selectedImage && selectedImage.name === file?.name) {
      toast.error("You cannot upload the same image again.");
      fileInputRef.current.value = "";
      return;
    }

    if (file && validTypes.includes(file.type)) {
      setImageLoading(true);
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
      formik.setFieldValue("image", file);
      setTimeout(() => {
        setImageLoading(false);
      }, 2000);
    } else {
      toast.error("Please upload a valid image (JPEG, PNG, or GIF).");
      fileInputRef.current.value = "";
    }
  };

  const handleCategoryChange = async (event) => {
    const { value } = event.target;

    const selectedCategory = categories.find((cat) => cat.slug === value);
    if (!selectedCategory) return;

    const categoryId = selectedCategory._id;
    const categorySlug = selectedCategory.slug;

    setIsSportCategory(categorySlug.toLowerCase() === "sports");
    setSubcategories([]);
    setSubChildcategories([]);
    formik.setFieldValue("slug", categorySlug);
    formik.setFieldTouched("slug", true);
    formik.setFieldValue("categoryId", "");
    setTimeout(() => formik.validateForm(), 0);

    try {
      const response = await apiCategory.category({ categoryId });
      setSubcategories(response?.data?.data || []);
    } catch (error) {
      setSubcategories([]);
    }
  };

  const handleSubCategoryChange = async (event) => {
    const category = event.target.value;
    setSubChildcategories([]);
    formik.setFieldValue("categoryId", category);
    formik.setFieldTouched("categoryId", true);
    formik.setFieldValue("subcategoryId", "");
    setTimeout(() => formik.validateForm(), 0);

    const payload = { categoryId: category };
    try {
      const response = await apiCategory.category(payload);
      const subcategoriesData = response.data?.data || [];
      if (subcategoriesData.length === 0) {
      } else {
        setSubChildcategories(subcategoriesData);
      }
    } catch (error) {
      setSubChildcategories([]);
    }
  };

  useEffect(() => {
    const fetchCategoryIfSlugExists = async () => {
      if (data?.originIds?.[0]?.id) {
        try {
          const payload = { categoryId: data?.originIds?.[0]?.id };
          const response = await apiCategory.category(payload);
          const subcategoriesData = response.data?.data || [];

          setSubcategories(subcategoriesData);
        } catch (error) {
          setSubcategories([]);
          errorHandler(error);
        }
      }
    };

    const fetchSubCategory = async () => {
      if (data?.originIds?.[1]?.id) {
        try {
          const payload = { categoryId: data?.originIds?.[1]?.id };
          const response = await apiCategory.category(payload);

          const subcategoriesData = response.data?.data || [];

          setSubChildcategories(subcategoriesData);
        } catch (error) {
          setSubChildcategories([]);
          errorHandler(error);
        }
      }
    };

    fetchSubCategory();
    fetchCategoryIfSlugExists();
  }, [data?.originIds?.[1]?.id, data?.originIds?.[0]?.id]);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await ticketServices.getCountries();
        setCountries(response?.data?.data || []);
      } catch (error) {
        setCountries([]);
      }
    };

    fetchCountries();
  }, []);

  const handleCountryChange = async (event) => {
    const { value } = event.target;
    formik.setFieldValue("country", value);
    formik.setFieldValue("state", "");
    formik.setFieldValue("city", "");

    try {
      const response = await ticketServices.getStatesByCountry({
        countryId: value,
        type:"dropdown"
      });
      setStates(response?.data?.data || []);
      setCities([]);
    } catch (error) {
      setStates([]);
    }
  };

  const handleStateChange = async (event) => {
    const { value } = event.target;
    formik.setFieldValue("state", value);
    formik.setFieldValue("city", "");

    try {
      const response = await ticketServices.getCity({ stateId: value , type:"dropdown" });
      setCities(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCities([]);
    }
  };

  const fetchTeamDropdown = async () => {
    try {
      const data = await Teams.getData();
      setTeamData(data?.data?.data);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setTeamData([]);
    }
  };

  const handleVenueImageChange = (event) => {
    const file = event.currentTarget.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];

    if (venueImage && venueImage.name === file?.name) {
      toast.error("You cannot upload the same image again.");
      venueImageInputRef.current.value = "";
      return;
    }

    if (file && validTypes.includes(file.type)) {
      setVenueImage(file);
      setVenueImagePreview(URL.createObjectURL(file));
      formik.setFieldValue("venueImage", file);
    } else {
      toast.error("Please upload a valid image (JPEG, PNG, or GIF).");
      venueImageInputRef.current.value = "";
    }
  };

  useEffect(() => {
    if (isSportCategory) {
      fetchTeamDropdown();
    }
  }, [isSportCategory]);

  return (
    <Box>
      <CardLayout>
        <CardHeader title={`${id ? "Edit" : "Add"} Ticket`} />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>


              <Grid container spacing={4}>
                {/* Profile Image Upload */}
                <Grid item xs={12} sm={6}>
                  <input
                    accept="image/*"
                    type="file"
                    ref={fileInputRef}
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />

                  <Box
                    mt={1}
                    p={2}
                    border="2px dashed #ccc"
                    borderRadius={2}
                    height={300} // fixed height
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      cursor: "pointer",
                      transition: "border-color 0.3s",
                      "&:hover": { borderColor: "primary.main" },
                      position: "relative",
                      overflow: "hidden",
                    }}
                    onClick={() => fileInputRef.current.click()}
                  >
                    {imageLoading ? (
                      <CircularProgress />
                    ) : imagePreview ? (
                      <Box
                        component="img"
                        src={imagePreview}
                        alt="Preview"
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 2,
                        }}
                      />
                    ) : (
                      <Button variant="contained" size="large">
                        {id ? "Edit" : "Upload"} Image
                      </Button>
                    )}
                  </Box>
                  {formik.touched.image && formik.errors.image && (
                    <FormHelperText error>{formik.errors.image}</FormHelperText>
                  )}
                </Grid>


                {/* Venue Image Upload */}
                <Grid item xs={12} sm={6}>
                  <input
                    accept="image/*"
                    type="file"
                    ref={venueImageInputRef}
                    onChange={handleVenueImageChange}
                    style={{ display: "none" }}
                  />

                  <Box
                    mt={1}
                    p={2}
                    border="2px dashed #ccc"
                    borderRadius={2}
                    height={300} // fixed height
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      cursor: "pointer",
                      transition: "border-color 0.3s",
                      "&:hover": { borderColor: "primary.main" },
                      position: "relative",
                      overflow: "hidden",
                    }}
                    onClick={() => venueImageInputRef.current.click()}
                  >
                    {venueImagePreview ? (
                      <Box
                        component="img"
                        src={venueImagePreview}
                        alt="Venue Preview"
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 2,
                        }}
                      />
                    ) : (
                      <Button variant="contained" size="large">
                        {id ? "Edit" : "Upload"} Venue Image
                      </Button>
                    )}
                  </Box>
                  {formik.touched.venueImage && formik.errors.venueImage && (
                    <FormHelperText error>{formik.errors.venueImage}</FormHelperText>
                  )}
                </Grid>


                <Grid item xs={6} md={6}>
                  <TextField
                    fullWidth
                    label="Name"
                    onPaste={(e) => {
                      const pastedText = e.clipboardData.getData("text");
                      if (/^\d+$/.test(pastedText)) {
                        e.preventDefault();
                      }
                    }}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    name="name"
                    error={Boolean(formik.touched.name && formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                    inputProps={{ maxLength: 50 }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <TextField
                    fullWidth
                    label="Bid Start Price"
                    onChange={(e) => {
                      const { value } = e.target;
                      if (/^\d+(\.\d{0,2})?$|^$/.test(value)) {
                        formik.setFieldValue("bidPrice", value);
                      }
                    }}
                    value={formik.values.bidPrice}
                    name="bidPrice"
                    error={Boolean(
                      formik.touched.bidPrice && formik.errors.bidPrice
                    )}
                    helperText={
                      formik.touched.bidPrice && formik.errors.bidPrice
                    }
                    inputProps={{ maxLength: 6 }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <TextField
                    fullWidth
                    label="Ticket Price"
                    onChange={(e) => {
                      const { value } = e.target;
                      if (/^\d+(\.\d{0,2})?$|^$/.test(value)) {
                        formik.setFieldValue("price", value);
                      }
                    }}
                    value={formik.values.price}
                    name="price"
                    error={Boolean(formik.touched.price && formik.errors.price)}
                    helperText={formik.touched.price && formik.errors.price}
                    inputProps={{
                      maxLength: 6,
                      onPaste: (e) => e.preventDefault(),
                    }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <TextField
                    fullWidth
                    label="Total Ticket"
                    value={formik.values.totalTicket}
                    onChange={(e) => {
                      const { value } = e.target;

                      if (/^[0-9]*$/.test(value)) {
                        formik.setFieldValue("totalTicket", value);
                      }
                    }}
                    name="totalTicket"
                    error={Boolean(
                      formik.touched.totalTicket && formik.errors.totalTicket
                    )}
                    helperText={
                      formik.touched.totalTicket && formik.errors.totalTicket
                    }
                    inputProps={{
                      maxLength: 6,
                      onPaste: (e) => {
                        e.preventDefault();
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Category Type"
                    value={formik?.values?.slug}
                    onChange={handleCategoryChange}
                    name="slug"
                    error={Boolean(formik.touched.slug && formik.errors.slug)}
                    helperText={formik.touched.slug && formik.errors.slug}
                  >
                    <MenuItem value=" ">Select Category</MenuItem>
                    {categories?.map((item) => (
                      <MenuItem
                        key={item._id}
                        value={item.slug}
                        data-id={item._id}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={6} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Category"
                    value={formik.values.categoryId}
                    onChange={handleSubCategoryChange}
                    name="categoryId"
                    error={Boolean(
                      formik.touched.categoryId && formik.errors.categoryId
                    )}
                    helperText={
                      formik.touched.categoryId && formik.errors.categoryId
                    }
                  >
                    <MenuItem value=" " disabled>
                      Select Sub Category
                    </MenuItem>
                    {subcategories?.map((sub, index) => (
                      <MenuItem key={index} value={sub._id}>
                        {capitalizeFirstLetter(sub.name)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {Childsubcategories.length > 0 ? (
                  <>
                    <Grid item xs={6} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Sub Category"
                        value={formik.values.subcategoryId}
                        onChange={formik.handleChange}
                        name="subcategoryId"
                        error={Boolean(
                          formik.touched.subcategoryId &&
                          formik.errors.subcategoryId
                        )}
                        helperText={
                          formik.touched.subcategoryId &&
                          formik.errors.subcategoryId
                        }
                      >
                        <MenuItem value="" disabled>
                          Select Sub Category
                        </MenuItem>
                        {Childsubcategories?.map((sub, index) => (
                          <MenuItem key={index} value={sub._id}>
                            {capitalizeFirstLetter(sub.name)}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={6} md={6}></Grid>
                  </>
                ) : (
                  ""
                )}

                {isSportCategory ? (
                  <>
                    <Grid item xs={6} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Team 1 Name"
                        value={formik.values.teamFirst || ""}
                        onChange={formik.handleChange}
                        name="teamFirst"
                        error={Boolean(
                          formik.touched.teamFirst && formik.errors.teamFirst
                        )}
                        helperText={
                          formik.touched.teamFirst && formik.errors.teamFirst
                        }
                      >
                        <MenuItem value="" disabled>
                          Select Team Name
                        </MenuItem>
                        {teamData?.map((sub, index) => (
                          <MenuItem key={index} value={sub.name}>
                            {capitalizeFirstLetter(sub.name)}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={6} md={6}>
                      <TextField
                        select
                        fullWidth
                        label="Team 2 Name"
                        value={formik.values.teamSecond || ""}
                        onChange={formik.handleChange}
                        name="teamSecond"
                        error={Boolean(
                          formik.touched.teamSecond && formik.errors.teamSecond
                        )}
                        helperText={
                          formik.touched.teamSecond && formik.errors.teamSecond
                        }
                      >
                        <MenuItem value="" disabled>
                          Select Team Name
                        </MenuItem>
                        {teamData
                          ?.filter(
                            (sub) => sub.name !== formik.values.teamFirst
                          )
                          .map((sub, index) => (
                            <MenuItem key={index} value={sub.name}>
                              {capitalizeFirstLetter(sub.name)}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} md={12}>
                    <TextField
                      fullWidth
                      label="Artist Name"
                      value={formik.values.artistName || ""}
                      onChange={formik.handleChange}
                      name="artistName"
                      error={Boolean(
                        formik.touched.artistName && formik.errors.artistName
                      )}
                      helperText={
                        formik.touched.artistName && formik.errors.artistName
                      }
                    />
                  </Grid>
                )}

                <Grid item xs={6}>
                  <Select
                    fullWidth
                    name="country"
                    value={formik?.values?.country}
                    onChange={handleCountryChange}
                    error={Boolean(
                      formik?.touched.country && formik?.errors?.country
                    )}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Country
                    </MenuItem>

                    {countries
                      ?.filter(country => country?.status !== false)
                      .map((country, index) => (
                        <MenuItem key={index} value={country?._id}>
                          {country.name}
                        </MenuItem>
                      ))}

                  </Select>
                  <FormHelperText
                    error={Boolean(
                      formik.touched.country && formik.errors.country
                    )}
                  >
                    {formik.touched.country && formik.errors.country}
                  </FormHelperText>
                </Grid>

                <Grid item xs={6}>
                  <Select
                    fullWidth
                    name="state"
                    value={formik.values.state}
                    onChange={handleStateChange}
                    error={Boolean(formik.touched.state && formik.errors.state)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select State
                    </MenuItem>
                    {states?.map((state, index) => (
                      <MenuItem key={index} value={state._id}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText
                    error={Boolean(formik.touched.state && formik.errors.state)}
                  >
                    {formik.touched.state && formik.errors.state}
                  </FormHelperText>
                </Grid>

                {console.log(formik.values.city, "Asdf")}
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    name="city"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    error={Boolean(formik.touched.city && formik.errors.city)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select City
                    </MenuItem>
                    {cities?.map((cityValue, index) => (
                      <MenuItem key={index} value={cityValue._id}>
                        {console.log(cityValue)}
                        {cityValue.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText
                    error={Boolean(formik.touched.city && formik.errors.city)}
                  >
                    {formik.touched.city && formik.errors.city}
                  </FormHelperText>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Venue"
                    name="venue"
                    value={formik.values.venue}
                    onChange={formik.handleChange}
                    error={Boolean(formik.touched.venue && formik.errors.venue)}
                    helperText={formik.touched.venue && formik.errors.venue}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Zip Code"
                    name="zipcode"
                    value={formik.values.zipcode}
                    onChange={formik.handleChange}
                    error={Boolean(
                      formik.touched.zipcode && formik.errors.zipcode
                    )}
                    helperText={formik.touched.zipcode && formik.errors.zipcode}
                  />
                </Grid>

                <Grid item xs={6} style={{ marginTop: "-8px" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["MobileTimePicker"]}>
                      <MobileDateTimePicker
                        className="custom-time-field"
                        label="Event Start Date"
                        value={formik?.values?.event_start_date}
                        onChange={(newValue) =>
                          formik.setFieldValue("event_start_date", newValue)
                        }
                        slots={{
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={Boolean(
                                formik.touched.event_start_date &&
                                formik.errors.event_start_date
                              )}
                              helperText={
                                formik.touched.event_start_date &&
                                formik.errors.event_start_date
                              }
                            />
                          ),
                        }}
                        inputFormat="MM/dd/yyyy hh:mm a"
                        ampm
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Section"
                    name="section"
                    value={formik.values.section}
                    onChange={formik.handleChange}
                    error={Boolean(
                      formik.touched.section && formik.errors.section
                    )}
                    helperText={formik.touched.section && formik.errors.section}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Row"
                    name="row"
                    value={formik.values.row}
                    onChange={formik.handleChange}
                    error={Boolean(formik.touched.row && formik.errors.row)}
                    helperText={formik.touched.row && formik.errors.row}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Full Address"
                    name="fullAddress"
                    value={formik.values.fullAddress}
                    onChange={formik.handleChange}
                    error={Boolean(
                      formik.touched.fullAddress && formik.errors.fullAddress
                    )}
                    helperText={
                      formik.touched.fullAddress && formik.errors.fullAddress
                    }
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={10}
                    maxRows={10}
                    label="Description"
                    onPaste={(e) => {
                      const pastedText = e.clipboardData.getData("text");
                      if (/^\d+$/.test(pastedText)) {
                        e.preventDefault();
                      }
                    }}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    name="description"
                    error={Boolean(
                      formik.touched.description && formik.errors.description
                    )}
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    labelId="status-label"
                    id="status"
                    value={formik.values.status}
                    onChange={(e) =>
                      formik.setFieldValue("status", e.target.value)
                    }
                    fullWidth
                    error={Boolean(
                      formik.touched.status && formik.errors.status
                    )}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="">Select Status</MenuItem>
                    <MenuItem value={"active"}>Active</MenuItem>
                    <MenuItem value={"inactive"}>Inactive</MenuItem>
                  </Select>
                  {formik.touched.status && formik.errors.status && (
                    <FormHelperText error>
                      {formik.errors.status}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box mt={3}>
                    <LoadingButton
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      loading={loading}
                    >
                      {id ? "Update" : "Add"} Ticket
                    </LoadingButton>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default AddEditTicket;
